import { Injectable, Type, Component } from '@angular/core';

import { Observable, Subject } from 'rxjs/';

@Injectable()
export class SmartModalService {

    private modalResult: Subject<ModalResult> = new Subject<ModalResult>();
    private modalOpen: Subject<ModalRequestEvent> = new Subject<ModalRequestEvent>();
    private modalClose: Subject<boolean> = new Subject<boolean>();
    private _isOpen: Observable<boolean>;

    constructor() {
        this._isOpen = Observable.merge(this.modalOpen.mapTo(true), this.modalClose.mapTo(false))
            .startWith(false)
            .distinctUntilChanged()
            .shareReplay();
    }

    public open(component: Type<Component>, data: any, title: string, size: ModalSize = ModalSize.Md, position: string = 'center',logoSrc?:string): Observable<ModalResult> {
        return Observable.defer(() => {
            // Close old modal and open new one
            this.modalClose.next(true);
            this.modalOpen.next(new ModalRequestEvent(component, data, title, size, position,logoSrc));

            // Return observable for the next modal result

            return this.modalResult
                .take(1)
                .flatMap(result => {
                    this.close();
                    if (result) {
                        return Observable.of(result);
                    }

                    throw new Error('Modal closed!');
                });
        });
    }

    public close(): void {
        this.modalClose.next(true);
    }

    public onModalOpen(): Observable<ModalRequestEvent> {
        return this.modalOpen.asObservable();
    }

    public onModalClose(): Observable<boolean> {
        return this.modalClose.asObservable();
    }

    public sendResult(result: any) {
        this.modalResult.next(result ? new ModalResult(result) : null);
    }

    public isOpen(): Observable<boolean> {
        return this._isOpen;
    }
}

export class ModalRequestEvent {

    constructor(
        public component: Type<Component>,
        public data: any,
        public title: string,
        public size: ModalSize,
        public position: string,
        public logoSrc?: string
    ) {

    }
}

export class ModalResult {

    constructor(public result: any) { }
}

export enum ModalSize {
    Sm, Md, Lg
}



// WEBPACK FOOTER //
// ./src/app/core/services/smart-modal.service.ts